import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { ProductCreate } from '../../services';

export const fetchProductCreate = createAsyncThunk(
    'productCreate/fetchProductCreate',
    async ({ file, slug, title, description, content, sort }) => {
        const response = await ProductCreate(file, slug, title, description, content, sort)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const productCreateSlice = createSlice({
    name: 'productCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProductCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchProductCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default productCreateSlice.reducer;
